import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Helper from '../Helper';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCheckbox,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
} from 'mdb-react-ui-kit';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
        method: 'POST',
        headers: {  'Accept': 'application/json',
      'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (response.ok) {

        if (data.changePasswordRequired) {
          // Redirect to the change password page
          navigate("/change-password/", { state: { userId: data.userId } });
        } else if (data.token) {


          // Save the JWT token in sessionStorage
          sessionStorage.setItem('authToken', data.token);
          var roles = Helper.getuserrole();
          navigate(data.default_page ? '/' + data.default_page : '/main'); // Redirect to main page
        }

      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
		console.log('fetch error', err.name, err.message, err.cause);
    }
  };

  return (
    <MDBContainer className="my-5">
      <MDBRow className="justify-content-center">
        <MDBCol md="6">
          <MDBCard>
            <MDBCardHeader className="text-center ">
              <h4>เข้าสู่ระบบ</h4>
            </MDBCardHeader>
            <MDBCardBody>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              <form onSubmit={handleLogin}>
                <MDBInput
                  label="รหัสผู้ใช้"
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="mb-4"
                  required
                />
                <MDBInput
                  label="รหัสผ่าน"
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mb-4"
                  required
                />
                <div className="d-grid">
                  <MDBBtn type="submit" color="primary">
                    ลงชื่อเข้าใช้
                  </MDBBtn>
                </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default LoginForm;
